export enum LabelType {
  BarcodeLabel = 1,
  PublicQr = 2,
  QrBarcodeLabels = 3,
  BarcodeCatalog = 4,
  PrePrintedLabel = 5
}
